// extracted by mini-css-extract-plugin
module.exports = {"CirclePicture":"styles_CirclePicture__80CLw","picture":"styles_picture__PDq2R","withShadow":"styles_withShadow__Qj5Pw"};